module.exports = __webpack_public_path__ + "img/road1.dad7d0ea.jpg";